// import TrashIcon from "../../../Assets/Icons/TrashIcon";
// import './checkout.css';

import { InstructionsContextProvider } from "../../../APIContext/InstructionsContext";
import CheckoutCom from "../../../Components/CheckoutCom";
import { NewUserContextProvider } from "../../../APIContext/NewUserContext";
import FormComUser from "../../../Components/InstructionsComNewUser/FormComUser";
import "./checkout.css";

const Checkout = () => {
  const user = localStorage.getItem("user");
  return (
    <NewUserContextProvider>
      <InstructionsContextProvider>
        <div className="prceed-with-new-customer bg-custom brightness">
          {!user ? <FormComUser /> : ""}
          <CheckoutCom />
        </div>
      </InstructionsContextProvider>
    </NewUserContextProvider>
  );
};

export default Checkout;
